import { FormBuilderType, FormBuilderValidator, FormBuilderState, validatorFunc } from "@grassrootly/rn-core";

export interface RegisterDTO {
  email: string;
  name: string;
  password: string;
  repeatPassword: string;
}

function validateRepeatPassword<T extends FormBuilderState<RegisterDTO>>(value: string, field: string, state?: T) {
  if (value && state?.password?.value && value !== state?.password?.value) {
    return {
      valid: false,
      error: "Repeat Password must me equal to Password",
    };
  }
  return {
    valid: true,
  };
}

export const registerForm: FormBuilderType<RegisterDTO> = {
  name: {
    type: "input",
    name: "name",
    label: "Full Name",
    defaultValue: "",
    validators: [FormBuilderValidator.required(), FormBuilderValidator.minChar(3)],
    required: true,
    props: {
      keyboardType: "name-phone-pad",
    },
  },
  email: {
    type: "input",
    name: "email",
    label: "Email",
    defaultValue: "",
    validators: [FormBuilderValidator.required(), FormBuilderValidator.email()],
    required: true,
    props: {
      keyboardType: "email-address",
    },
  },
  password: {
    type: "password",
    name: "password",
    label: "Password",
    defaultValue: "",
    validators: [FormBuilderValidator.required(), FormBuilderValidator.password()],
    required: true,
    props: {
      keyboardType: "visible-password",
    },
  },
  repeatPassword: {
    type: "password",
    name: "repeatPassword",
    label: "Repeat Password",
    defaultValue: "",
    validators: [FormBuilderValidator.required(), FormBuilderValidator.custom(validateRepeatPassword as validatorFunc)],
    required: true,
    props: {
      keyboardType: "visible-password",
    },
  },
};
